export default __webpack_public_path__ + "img/zonahorariamexico.2ee07340.jpg";